import React from 'react';
import MetaData from '../../../components/meta-data';
import Layout from '../../../components/layout';
import Headline from '../../../components/headline';
import Breadcrumbs from '../../../components/breadcrumbs';
var ProductIndex = function ProductIndex(props) {
    var _props$data$seo$edges, _props$data$seo$edges2, _props$data$seo$edges3, _props$data$studioThr;
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(MetaData, {
        title: "Project Photos",
        description: "Some photos I've taken for some various projects, showcasing various things.  This collection will have more added to it soon once I can.",
        photos: {
            full: (_props$data$seo$edges = props.data.seo.edges[0].node.full) === null || _props$data$seo$edges === void 0 ? void 0 : _props$data$seo$edges.fixed,
            facebook: (_props$data$seo$edges2 = props.data.seo.edges[0].node.facebook) === null || _props$data$seo$edges2 === void 0 ? void 0 : _props$data$seo$edges2.fixed,
            twitter: (_props$data$seo$edges3 = props.data.seo.edges[0].node.twitter) === null || _props$data$seo$edges3 === void 0 ? void 0 : _props$data$seo$edges3.fixed
        }
    }), /*#__PURE__*/ React.createElement(Breadcrumbs, {
        path: props
    }), /*#__PURE__*/ React.createElement("div", {
        className: "grid"
    }, /*#__PURE__*/ React.createElement("section", {
        className: "copy"
    }, /*#__PURE__*/ React.createElement("h1", null, "Projects"), /*#__PURE__*/ React.createElement("p", null, "Some photos I've taken for some various projects, showcasing various products. This collection will have more added to it soon once I can."))), /*#__PURE__*/ React.createElement(Headline, {
        imagePlacement: 'left',
        image: {
            source: (_props$data$studioThr = props.data.studioThree.edges[Math.floor(Math.random() * props.data.studioThree.edges.length)].node.childImageSharp) === null || _props$data$studioThr === void 0 ? void 0 : _props$data$studioThr.fluid,
            altText: 'Studio Three'
        },
        link: '/photos/projects/studio-three/',
        copy: {
            headline: {
                h1: 'Studio Three'
            },
            text: 'Project photos for Studio Three fitness studio in Chicago.'
        }
    }));
};
export default ProductIndex;
var query = "505923005";
